import React, { CSSProperties } from 'react';
import { StylesConfig, OnChangeValue } from 'react-select';

import MFormSelectView from './MFormSelect.view';

import { MFormFieldProps } from 'views/MForm/MForm.model';
import { MReactSelectOption, MSelectChangeData, MSelectOption } from 'views/MSelect/MSelect.model';

type Props<Value, Id extends string, IsMulti extends boolean> = MFormFieldProps<
  [OnChangeValue<MSelectChangeData<Value, Id>, IsMulti>],
  IsMulti extends true
    ? (MSelectOption<Value, Id> | MSelectOption<Value, Id>['id'])[]
    : MSelectOption<Value, Id> | MSelectOption<Value, Id>['id'] | null
> & {
  className?: string;
  heightOptions?: string;
  placeholder?: string;
  options: MSelectOption<Value, Id>[];
  isMulti?: IsMulti;
  customStylesSelect?: StylesConfig<MReactSelectOption, IsMulti>;
  hideSelectedOptions?: boolean;
  controlColor?: string;
  showSelected?: boolean;
  disabled?: boolean;
  hideEffectSelection?: boolean;
  disabledValueColor?: string;
  isCreatable?: boolean;
  isClearable?: boolean;
  transparentBorder?: boolean;
  indicatorsContainerColor?: string;
  dropDownInputColor?: CSSProperties;
};

const MFormSelect = <Value, Id extends string = string, IsMulti extends boolean = false>(props: Props<Value, Id, IsMulti>): JSX.Element => {
  return (
    <MFormSelectView
      heightOptions={props.heightOptions}
      transparentBorder={props.transparentBorder}
      isCreatable={props.isCreatable}
      className={props.className}
      placeholder={props.placeholder}
      options={props.options}
      isMulti={props.isMulti}
      value={props.value}
      controlColor={props.controlColor}
      customStylesSelect={props.customStylesSelect}
      name={props.name}
      valid={props.valid}
      invalid={props.invalid}
      isClearable={props.isClearable}
      hideSelectedOptions={props.hideSelectedOptions}
      showSelected={props.showSelected}
      disabled={props.disabled}
      indicatorsContainerColor={props.indicatorsContainerColor}
      hideEffectSelection={props.hideEffectSelection}
      onChange={props.onChange}
      disabledValueColor={props.disabledValueColor}
      dropDownInputColor={props.dropDownInputColor}
    ></MFormSelectView>
  );
};

MFormSelect.displayName = 'MFormSelect';
MFormSelect.defaultProps = {};

export default MFormSelect;
